import { apiForm } from '@spo/services/api';
import { PostApiSpoFormCreateUserNeedBody } from '@spo/types';
import { useQuery } from '@tanstack/react-query';

export const useFormCreateUserNeed = (
  postApiSpoFormCreateUserNeedBod: PostApiSpoFormCreateUserNeedBody,
) => {
  return useQuery({
    queryKey: ['useFormCreateUserNeed', postApiSpoFormCreateUserNeedBod],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted && postApiSpoFormCreateUserNeedBod) {
        const response = await apiForm.getFormCreateUserNeed(
          postApiSpoFormCreateUserNeedBod,
        );
        return response;
      }
    },
    enabled:
      Boolean(postApiSpoFormCreateUserNeedBod.natureId) &&
      Boolean(postApiSpoFormCreateUserNeedBod.sportId),
  });
};
